import script from "./EvCarDamageReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./EvCarDamageReport.vue?vue&type=script&lang=ts&setup=true"

import "./EvCarDamageReport.vue?vue&type=style&index=0&id=51d56d41&scoped=true&lang=css"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51d56d41"]])

export default __exports__